import {
  LOADING_ORDERS,
  RECEIVE_ORDERS,
  RECEIVE_ORDER,
  SEARCH_ORDERS,
  SEARCH_ORDERS_STATUS,
  SEARCH_ORDERS_HOURS,
  ERROR_ORDERS, UPDATE_ORDER,
} from '../actions';

function orders(
  state = {
    isFetching: false,
    loaded: false,
    error: null,
    message: '',
    list: [],
    search: '',
    searchStatus: {
      id: 0,
      color: '',
      label: 'Todos os pedidos',
    },
    searchHours: {
      id: 1,
      label: 'Últimas 24 horas',
      value: 24,
    },
  },
  action
) {
  switch (action.type) {
    case LOADING_ORDERS:
      return Object.assign({}, state, {
        isFetching: true,
        error: null,
      });
    case UPDATE_ORDER:
    case RECEIVE_ORDER: {
      const index = state.list.findIndex(item => item.id == action.order.id);
      if (index < 0) {
        return state;
      }
      const newList = state.list.slice();
      newList[index] = {
        ...state.list[index],
        ...action.order,
      };
      return {
        ...state,
        list: newList,
      };
    }
    case RECEIVE_ORDERS:
      return Object.assign({}, state, {
        isFetching: false,
        loaded: true,
        list: action.orders.sort((a, b) => {
          return b.id - a.id;
        }),
      });
    case SEARCH_ORDERS_STATUS:
      return Object.assign({}, state, {
        searchStatus: action.status,
      });
    case SEARCH_ORDERS:
      return Object.assign({}, state, {
        search: action.search,
      });
    case SEARCH_ORDERS_HOURS:
      return Object.assign({}, state, {
        searchHours: action.hours,
      });
    case ERROR_ORDERS:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export function getOrdersBySearch(searchParams, list) {
  const search = searchParams.toLocaleLowerCase().trim();
  let ordersFiltered = list.slice(0);

  if (search.length) {
    ordersFiltered = list.filter(item => {
      const id = item.id.toString();
      return (
        id.trim().includes(search) ||
        (item.customer.name !== null &&
          item.customer.name
            .toLocaleLowerCase()
            .trim()
            .includes(search))
      ); //eslint-disable-line
    });
  }

  return ordersFiltered;
}

export function getOrdersByStatus(state, status) {
  if (status.id === 0) return state.list;

  return state.list.filter(item => {
    return item.status === status.id;
  });
}

export default orders;



// WEBPACK FOOTER //
// ./src/reducers/orders.js